import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import RadioButtonGroup from '@/components/common/RadioButtonGroup/RadioButtonGroup.vue';
import MegaphoneIcon from '@/components/partials/war-room/WarRoomPostPollV2/images/megaphone-icon.vue.svg';
import WarRoomPostPollResults from '@/components/partials/war-room/WarRoomPostPollV2/WarRoomPostPollV2Results/WarRoomPostPollV2Results.vue';
import { sortByField } from '@/components/utils/sorting_func';
import type { IPost } from '@/types/community';

type WarRoomPostPollV2Props = {
  post: IPost;
};
type WarRoomPostPollV2Emits = {
  (event: 'vote', choiceId: number): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostPollV2',
  props: {
    post: null
  },
  emits: ["vote"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'vote', choiceId: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  post: IPost;
};




const { $auth } = useContext();

const poll = computed(() => props.post.poll);
const isChoicesVisible = computed(() => poll.value && poll.value.choices.length < 5);
const isAuthor = computed(() => props.post.user_username === $auth.user?.username);
const votable = computed(() => {
  if (isAuthor.value) return false;

  return !!poll.value?.choices.some(({ current_vote: currentVote }) => currentVote);
});
const votersCount = computed(() => poll.value?.votes_count ?? 0);
const showHint = computed(() => isChoicesVisible.value && votable.value && !!poll.value?.expired_for_commission);
const radioButtonsConfig = computed(() =>
  poll.value?.choices
    .map(({ id, text, position }) => ({
      label: text,
      value: id.toString(),
      position,
      size: 'sm',
    }))
    .sort(sortByField('position')),
);
const pollClasses = computed(() => ({
  'war-room-post-poll--disabled': !$auth.loggedIn,
  'war-room-post-poll--pinned': props.post.pinned,
}));

function onPollVote(choiceId: number) {
  if ($auth.loggedIn) emit('vote', choiceId);
}

return { __sfc: true,props, emit, $auth, poll, isChoicesVisible, isAuthor, votable, votersCount, showHint, radioButtonsConfig, pollClasses, onPollVote, BravadoText, RadioButtonGroup, MegaphoneIcon, WarRoomPostPollResults }
}

})